module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contactus"
  }, [_c('ul', {
    staticClass: "ui-list ui-list-text contact"
  }, [_c('li', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "ui-list-info"
  }, [_vm._v(_vm._s(_vm.phone))])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "padding": "1rem 0"
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "ui-list-info"
  }, [_vm._v(_vm._s(_vm.address))])]), _vm._v(" "), _c('li', [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "ui-list-info"
  }, [_vm._v(_vm._s(_vm.code))])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contact-title"
  }, [_c('span', [_vm._v("联系电话:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contact-title"
  }, [_c('span', [_vm._v("联系地址:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contact-title"
  }, [_c('span', [_vm._v("邮编:")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d732f00c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/contact.vue
// module id = 241
// module chunks = 1